<template>
  <div>
    <DepartmentLiquidation
      :title="'DAMAYAN REVOLVING FUND'"
    />
  </div>
</template>
<script>
  import DepartmentLiquidation
    from '@/views/input_interface/monthly_liquidation/ChequeFundLiquidation'

  export default {
    components: {
      DepartmentLiquidation,
    },
  }
</script>
